module.exports = __webpack_public_path__ + "img/ideas-workbench-white.98c2a366.svg";